import React from 'react';

// Lightning bolt SVG component that matches the brand image
const LightningBolt = ({ size = 32, className = "" }) => {
  const scale = size / 100;
  return (
    <svg 
      width={size * 0.8} 
      height={size} 
      viewBox="0 0 80 100" 
      className={className}
      style={{ filter: 'drop-shadow(0 0 2px rgba(255, 215, 0, 0.5))' }}
    >
      <defs>
        <linearGradient id="boltGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFED4A" />
          <stop offset="50%" stopColor="#FFD700" />
          <stop offset="100%" stopColor="#FFA500" />
        </linearGradient>
      </defs>
      {/* Main lightning bolt - zig-zag shape */}
      <path 
        d="M45 0 L25 40 L40 40 L20 70 L35 70 L10 100 L50 60 L35 60 L55 30 L40 30 L60 0 Z" 
        fill="url(#boltGradient)"
      />
      {/* Small spark - top right */}
      <path 
        d="M62 25 L55 35 L60 35 L52 48 L68 32 L62 32 L70 20 Z" 
        fill="url(#boltGradient)"
        opacity="0.9"
      />
      {/* Small spark - middle right */}
      <path 
        d="M58 55 L52 62 L56 62 L48 72 L62 60 L57 60 L65 50 Z" 
        fill="url(#boltGradient)"
        opacity="0.8"
      />
    </svg>
  );
};

const Logo = ({ size = 'md', showText = true }) => {
  const sizes = {
    xs: { icon: 24, text: 'text-sm' },
    sm: { icon: 32, text: 'text-lg' },
    md: { icon: 40, text: 'text-xl' },
    lg: { icon: 56, text: 'text-2xl' },
    xl: { icon: 72, text: 'text-3xl' }
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-0">
      {showText && (
        <div className={`font-bold ${text} tracking-tight flex items-center`}>
          <span className="text-white">BARUERI</span>
          <LightningBolt size={icon} className="mx-0" />
          <span className="text-[#FFD700]">FLASH</span>
        </div>
      )}
      {!showText && (
        <LightningBolt size={icon} />
      )}
    </div>
  );
};

// White variant for dark backgrounds
export const LogoWhite = ({ size = 'md', showText = true }) => {
  const sizes = {
    xs: { icon: 24, text: 'text-sm' },
    sm: { icon: 32, text: 'text-lg' },
    md: { icon: 40, text: 'text-xl' },
    lg: { icon: 56, text: 'text-2xl' },
    xl: { icon: 72, text: 'text-3xl' }
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-0">
      {showText && (
        <div className={`font-bold ${text} tracking-tight flex items-center`}>
          <span className="text-white">BARUERI</span>
          <LightningBolt size={icon} className="mx-0" />
          <span className="text-[#FFD700]">FLASH</span>
        </div>
      )}
      {!showText && (
        <LightningBolt size={icon} />
      )}
    </div>
  );
};

// Dark variant for light backgrounds
export const LogoDark = ({ size = 'md', showText = true }) => {
  const sizes = {
    xs: { icon: 24, text: 'text-sm' },
    sm: { icon: 32, text: 'text-lg' },
    md: { icon: 40, text: 'text-xl' },
    lg: { icon: 56, text: 'text-2xl' },
    xl: { icon: 72, text: 'text-3xl' }
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-0">
      {showText && (
        <div className={`font-bold ${text} tracking-tight flex items-center`}>
          <span className="text-[#1A1A1A]">BARUERI</span>
          <LightningBolt size={icon} className="mx-0" />
          <span className="text-[#FFD700]">FLASH</span>
        </div>
      )}
      {!showText && (
        <LightningBolt size={icon} />
      )}
    </div>
  );
};

// Export the lightning bolt component separately for inline use
export { LightningBolt };

export default Logo;
